/**
 *  Module for charts library
 */

import PieChartDirective from './directives/piechart/pieChart';
import LineChartDirective from './directives/linechart/lineChart';

export default angular.module('edge.platform.charts', [])
    .directive('gwPieChart', PieChartDirective)
    .directive('gwLineChart', LineChartDirective);